<lib-tb-modal-notification [custom]="modalData">
  <ng-template libTbTemplate="body">
    <div class="text-sintc" *ngIf="modal === 'NoExistingTC'" >
      <h1 class="text-mobile">¿Sin tarjeta de Crédito Davivienda?</h1>
      <h3 class="text-mobile">No encontramos una tarjeta asociada a sus datos.</h3>
      <h4 class="text-mobile">No se preocupe, puede solicitarla ahora y disfrutar de todos sus beneficios</h4>
      <div class="content-btn">
        <button
          class="button_red"
          (click)="goToDavivienda(); tagTcDavivienda('Solicítela aquí')"
        >
          Solicítela aquí
        </button>
      </div>
    </div>
    <div class="text-sintc" *ngIf="modal === 'InactiveTC'">
      <h2 class="text-mobile">Parece que ésta tarjeta de crédito está inactiva</h2>
      <h3 class="text-mobile">Disfrute de todos los beneficios activándola ahora. Lo invitamos a comunicarse a los canales de atención del banco Davivienda, llamando al (601) 3383838.</h3>
    </div>
  </ng-template>
</lib-tb-modal-notification>
